import { render, staticRenderFns } from "./ProduitAdministration.vue?vue&type=template&id=8b03d28c&"
import script from "./ProduitAdministration.vue?vue&type=script&lang=ts&"
export * from "./ProduitAdministration.vue?vue&type=script&lang=ts&"
import style0 from "./ProduitAdministration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports